import { render, staticRenderFns } from "./77.vue?vue&type=template&id=972b1de6&scoped=true&"
import script from "./77.vue?vue&type=script&lang=js&"
export * from "./77.vue?vue&type=script&lang=js&"
import style0 from "./77.vue?vue&type=style&index=0&id=972b1de6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972b1de6",
  null
  
)

export default component.exports